module.exports = __webpack_public_path__ + "img/add_img.29a2bcaf.png";